import { mountComponent } from '../util/mount';
import { AppHtmlId, HtmlId } from '../enums/elementId';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    createPromotionalCard,
    PromotionalCard,
} from '@vfde-brix/ws10/promotional-card';
import { showElement } from '../util/visibility';
import { getCMSConfig } from '../util/cms';
import { HomesPassedType } from '../enums/product';
import { AccessSupplier, AvailabilityIndicator } from '../enums/product';

/**
 * Create Brix Promotional Card component.
 *
 * @param id - Wrapper ID of the element.
 * @returns Promotional card component or null if
 * the element with the given ID is not found.
 */
export const mountPromotionalCard = (id: HtmlId) =>
    mountComponent(id, createPromotionalCard, NO_PATTERN_BUSINESS_LOGIC);

export const updatePromotionalCard = (
    comp?: PromotionalCard,
    accessSupplier?: string,
    availabilityIndicator?: string,
    homesPassed?: HomesPassedType
) => {
    const { promotionalCard } = getCMSConfig();

    if (
        !comp ||
        !promotionalCard ||
        accessSupplier !== AccessSupplier.VFDE ||
        !availabilityIndicator
    ) {
        showElement(AppHtmlId.FIXNET_WHOLYBUY_CARD, false);
        return;
    }

    let promotionalData;

    switch (availabilityIndicator) {
        case AvailabilityIndicator.GELB_GRAU:
            promotionalData = promotionalCard.fiberInExpansion;
            break;
        case AvailabilityIndicator.ORANGE_ROT:
        case AvailabilityIndicator.ROT_ORANGE:
            if (homesPassed === HomesPassedType.BKV) {
                promotionalData = promotionalCard.fiberAvailable;
            }
            break;
        default:
            promotionalData = undefined;
    }

    if (promotionalData) {
        comp.update({
            stdLabel: promotionalData.label,
            stdSystemIconName: promotionalData.icon,
            txtSublabel: promotionalData.subLabel,
        });
        showElement(AppHtmlId.FIXNET_WHOLYBUY_CARD, true);
    } else {
        showElement(AppHtmlId.FIXNET_WHOLYBUY_CARD, false);
    }
};
